import { render, staticRenderFns } from "./AdministrationHistory.vue?vue&type=template&id=8006809c&scoped=true&lang=pug"
import script from "./AdministrationHistory.vue?vue&type=script&lang=js"
export * from "./AdministrationHistory.vue?vue&type=script&lang=js"
import style0 from "./AdministrationHistory.vue?vue&type=style&index=0&id=8006809c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006809c",
  null
  
)

export default component.exports